import { DEFAULT_ERROR } from "../constants/errors";
import { AlertMessage } from "./AlertMessage";
import ASLogo from "./icons/ASLogo";
import WarningIcon from "./icons/WarningIcon";

const AccessDenied = () => {
  return (
    <div className="h-100 p-4">
      <ASLogo height={60} />
      <div className="d-flex flex-column gap-4 h-100 align-items-center justify-content-center">
        <AlertMessage type="danger">
          <div className="d-flex gap-2 align-items-center justify-content-center">
            <WarningIcon height={24} />
            <span>{DEFAULT_ERROR.authenticationError}</span>
          </div>
        </AlertMessage>
      </div>
    </div>
  );
};

export default AccessDenied;
